import { Directive, ElementRef, HostListener, Input, Output, EventEmitter, Renderer2, AfterViewInit, OnDestroy, ContentChild } from '@angular/core';

@Directive({
    selector: '[sizeable]',
    standalone: false
})
export class SizeableDirective implements AfterViewInit, OnDestroy {

  @Input() sizeableHandle?: HTMLElement;
  @Input() handleSelector = '.resize-handle';

  @Input('sizebleDisabled') disabled = false;    
  @Input('sizebleContainer') container!: HTMLElement;
  @Output() sizeChange = new EventEmitter<{ width: number, height: number }>();

  private startX = 0;
  private startY = 0;
  private startWidth = 0;
  private startHeight = 0;

  private MIN_SIZE_PX = 50;

  private removeMoveListener?: () => void;
  private removeUpListener?: () => void;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) { }

  public get handleEl() {
    return this.sizeableHandle || this.el.nativeElement.querySelector(this.handleSelector) || this.el.nativeElement;
  }

  ngAfterViewInit(): void {
    if (!this.handleEl) {
      return;
    }

    this.renderer.listen(this.handleEl, 'mousedown', (event: MouseEvent) => {
      if (this.disabled) {
        return;
      }
    
      event.preventDefault();
      event.stopPropagation();

      const rect = this.el.nativeElement.getBoundingClientRect();

      this.startX = event.clientX;
      this.startY = event.clientY;
      this.startWidth = rect.width;
      this.startHeight = rect.height;

      this.startResize();
    });
  }

  private startResize() {
    this.removeMoveListener = this.renderer.listen('document', 'mousemove', (event: MouseEvent) => {
      event.preventDefault();
      event.stopPropagation();
      this.onMouseMove(event);
    });

    this.removeUpListener = this.renderer.listen('document', 'mouseup', (event: MouseEvent) => {
      event.preventDefault();
      event.stopPropagation();

      this.stopResize();
    });
  }

  private onMouseMove(event: MouseEvent) {
    const parent = this.container;

    if (!parent) {
      return;
    }

    const parentRect = parent.getBoundingClientRect();

    const deltaX = event.clientX - this.startX;
    const deltaY = event.clientY - this.startY;

    const widthPx = Math.max(this.startWidth + deltaX, this.MIN_SIZE_PX);
    const heightPx = Math.max(this.startHeight + deltaY, this.MIN_SIZE_PX);

    let widthPct = (widthPx / parentRect.width) * 100;
    let heightPct = (heightPx / parentRect.height) * 100;

    widthPct = Math.min(Math.max(widthPct, 1), 100);
    heightPct = Math.min(Math.max(heightPct, 1), 100);

    this.sizeChange.emit({
      width: Math.round(widthPct * 100) / 100,
      height: Math.round(heightPct * 100) / 100
    });
  }

  private stopResize() {
    this.removeMoveListener?.();
    this.removeUpListener?.();
  }

  ngOnDestroy(): void {
    this.stopResize();
  }
}